import { getPost, updateSaveBtn, updateLikeBtn } from "./postAPI";
import {fetchPosts} from "../posts/postsSlice";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");


const initialState = {
    post: {},
    isLoading: false,
    isError: false,
    error: "",
};



// async thunk
export const fetchPost = createAsyncThunk("post/fetchPost", async (id) => {
    const post = await getPost(id);
    return post;
});
export const updateSaveBtnServer = createAsyncThunk("post/updateSaveBtnServer", async ({postId, isSaved}) => {    
    const post = await updateSaveBtn(postId, isSaved);   
    return post;
});
export const updateLikeBtnServer = createAsyncThunk("post/updateLikeBtnServer", async ({postId, likes}) => {    
    const post = await updateLikeBtn(postId, likes);   
    return post;
});

const postSlice = createSlice({
    name: "post",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchPost.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchPost.fulfilled, (state, action) => {
                state.isLoading = false;
                state.post = action.payload;
            })
            .addCase(fetchPost.rejected, (state, action) => {
                state.isLoading = false;
                state.post = {};
                state.isError = true;
                state.error = action.error?.message;
            })
            .addCase(updateSaveBtnServer.fulfilled, (state, action)=>{
                state.isLoading = false;
                state.post.isSaved = action.payload.isSaved;
            })
            .addCase(updateLikeBtnServer.fulfilled, (state, action)=>{
                state.isLoading = false;
                state.post.likes = action.payload.likes;                
            })
    },
});

export default postSlice.reducer;
